import React from 'react';
import { Modal, Button, Icon, Message } from 'semantic-ui-react';

const WithdrawalSuccessModal = ({ 
    open, 
    onClose, 
    requestData = null 
}) => {
    return (
        <Modal
            open={open}
            onClose={onClose}
            size="small"
            closeOnDimmerClick
            closeOnEscape
        >
            <Modal.Header>
                <Icon name="check circle" color="green" />
                Request Withdrawn Successfully
            </Modal.Header>
            
            <Modal.Content>
                {(
                    <Message success>
                        <Message.Header>Request has been withdrawn</Message.Header>
                        <p>Your request has been successfully withdrawn and the status has been updated.</p>
                        {requestData && (
                            <div style={{ marginTop: '10px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '4px' }}>
                                <strong>Request ID:</strong> {requestData.id}<br />
                                <strong>Status:</strong> Withdrawn
                            </div>
                        )}
                    </Message>
                )}
            </Modal.Content>

            <Modal.Actions>
                <Button 
                    positive
                    onClick={onClose}
                >
                    OK
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

export default WithdrawalSuccessModal;
